import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store";
import { selectStringParam } from "@/store/selectors";

const selectRouteList = (state: RootState) => state.manager.routeList;

export const selectRouteById = createSelector(
    [selectRouteList, selectStringParam],
    (routeList, routeId) => {
        return routeList?.[routeId];
    },
);
